import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import './RetroModal.scss';

/**
 * PaymentModal stellt eine visuelle Zahlungsschnittstelle (Mockup) bereit,
 * über die Schüler eine Lerneinheit per Kreditkarte bezahlen können.
 */
export default function PaymentModal({ show, onHide, termin, onConfirm }) {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('form');

  /**
   * Führt die Zahlung aus und simuliert eine kurze Verarbeitungszeit.
   */
  const handlePay = async (e) => {
    e.preventDefault();
    setStep('processing');
    setLoading(true);
    
    // Künstliche Verzögerung zur Simulation der Banktransaktion
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    try {
      await onConfirm(termin.id);
      setStep('success');
      setTimeout(() => {
        onHide();
        setStep('form');
        setLoading(false);
      }, 1500);
    } catch (err) {
      alert("Zahlung fehlgeschlagen: " + err.message);
      setStep('form');
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="retro-modal payment-modal">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="w-100 text-center mt-3">
          <h2 style={{ fontFamily: "'Lora', serif", color: '#2c3e50' }}>
            {step === 'success' ? 'Zahlung erfolgreich!' : 'Sicher bezahlen'}
          </h2>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="p-4">
        {step === 'form' && (
          <Form onSubmit={handlePay}>
            <div className="termin-summary mb-4 p-3 rounded" style={{ backgroundColor: '#fdfaf7', border: '1px solid #eee' }}>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Lerneinheit:</span>
                <span className="fw-bold">{termin?.skillName}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Dozent:</span>
                <span>{termin?.tutor?.vollerName}</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between align-items-center">
                <span className="h5 mb-0">Gesamtbetrag:</span>
                <span className="h4 mb-0" style={{ color: '#b95c50', fontWeight: 800 }}>
                  {termin?.preis ? Number(termin.preis).toFixed(2) : '0.00'} €
                </span>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted text-uppercase">Kreditkartennummer</Form.Label>
              <InputGroupWithIcon icon="bi-credit-card">
                <Form.Control 
                  required 
                  placeholder="0000 0000 0000 0000" 
                  maxLength="19"
                  className="vintage-input"
                />
              </InputGroupWithIcon>
            </Form.Group>

            <Row>
              <Col xs={7}>
                <Form.Group className="mb-4">
                  <Form.Label className="small fw-bold text-muted text-uppercase">Gültig bis</Form.Label>
                  <Form.Control required placeholder="MM / YY" maxLength="5" className="vintage-input" />
                </Form.Group>
              </Col>
              <Col xs={5}>
                <Form.Group className="mb-4">
                  <Form.Label className="small fw-bold text-muted text-uppercase">CVV</Form.Label>
                  <Form.Control required placeholder="123" maxLength="3" className="vintage-input" />
                </Form.Group>
              </Col>
            </Row>

            <Button 
              type="submit" 
              className="w-100 py-3 rounded-pill border-0 shadow-sm"
              style={{ background: 'linear-gradient(135deg, #b95c50 0%, #d88b7f 100%)', fontWeight: 700, fontSize: '1.1rem' }}
            >
              Jetzt sicher bezahlen
            </Button>
            <p className="text-center mt-3 small text-muted">
              <i className="bi bi-shield-lock-fill me-2"></i>
              Ihre Zahlung ist SSL-verschlüsselt und sicher.
            </p>
          </Form>
        )}

        {step === 'processing' && (
          <div className="text-center py-5">
            <Spinner animation="border" style={{ color: '#b95c50', width: '3rem', height: '3rem' }} />
            <h4 className="mt-4" style={{ color: '#2c3e50' }}>Zahlung wird verarbeitet...</h4>
            <p className="text-muted">Bitte schließen Sie dieses Fenster nicht.</p>
          </div>
        )}

        {step === 'success' && (
          <div className="text-center py-5">
            <div className="success-icon mb-4" style={{ fontSize: '5rem', color: '#059669' }}>
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <p className="text-muted">Vielen Dank für Ihre Buchung!</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

/**
 * Hilfskomponente zur Darstellung von Eingabefeldern mit integriertem Icon.
 */
function InputGroupWithIcon({ icon, children }) {
  return (
    <div className="position-relative">
      <span className="position-absolute" style={{ left: '15px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, color: '#adb5bd' }}>
        <i className={`bi ${icon}`}></i>
      </span>
      {React.cloneElement(children, { style: { paddingLeft: '45px' } })}
    </div>
  );
}
